/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.gemini.integration.rpc.AppSettingsRpc
 */

export const installRpc = {
  serviceName: 'com.hubspot.gemini.integration.rpc.AppSettingsRpc',
  rpcName: 'install',
  auth: 'app',
  fingerprint: 'rw9ida76Tsh7WbGSwWSomTDyMmaran50',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const uninstallRpc = {
  serviceName: 'com.hubspot.gemini.integration.rpc.AppSettingsRpc',
  rpcName: 'uninstall',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAB7WbGSwWSomTDyMmaran50',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertApiKeyRpc = {
  serviceName: 'com.hubspot.gemini.integration.rpc.AppSettingsRpc',
  rpcName: 'upsertApiKey',
  auth: 'app',
  fingerprint: 'Sl4Hrbl9dmFO1HCR1C86xTDyMmaran50',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};